import React from 'react';
import { Client } from '../../types/menu';
import Product from './Product';
import { WithClassname } from '../../types';

type Props = WithClassname & {
  data: Client.Category;
  onAddProduct: (product: Client.Product) => void;
};

export default function Category({ data, onAddProduct, className }: Props) {
  return (
    <div id={`category-${data.id}`} className={className}>
      <h6 className="underline">{data.name}</h6>
      {data.products.map((item) => (
        <Product data={item} onAdd={onAddProduct} key={`product-${item.id}`} />
      ))}
    </div>
  );
}
